import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import { ModalStyles } from '@stories/Components/Media/Modal/Modal.styles';
import styled from 'styled-components';
const Inner = styled.div `
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  ${ButtonStyles.Button} {
    margin-top: 20px;
  }

  ${ModalStyles.Title} {
    width: 100%;
  }
`;
export const ExtendHireStyles = {
    Inner,
};
